import { SupportedLanguage }  from '@/hooks/useTranslations';
import CodeServiceModel       from '@/models/CodeServiceModel';
import doc                    from '@widesk-core/decorators/doc';
import model                  from '@widesk-core/decorators/model';
import CodeEntertainmentModel from './CodeEntertainmentModel';
import ProductVariantModel    from '@/models/services/shop/ProductVariantModel.ts';

@model.urnResource('code_type')
@doc.path('/code_types/{?id}')
export default class CodeTypeModel extends CodeServiceModel {
	private declare _tsFilters: {
		'codeEntertainment': id;
		'codeEntertainment.entertainmentUrn': Urn;
		'createdAt[after]': string | Date | Dayjs;
		'createdAt[before]': string | Date | Dayjs;
		'createdAt[strictly_after]': string | Date | Dayjs;
		'createdAt[strictly_before]': string | Date | Dayjs;
		'sourceUrn': Urn;
		'updatedAt[after]': string | Date | Dayjs;
		'updatedAt[before]': string | Date | Dayjs;
		'updatedAt[strictly_after]': string | Date | Dayjs;
		'updatedAt[strictly_before]': string | Date | Dayjs;
	};

	private declare _tsSorts: {
		'createdAt': string;
		'id': string;
		'updatedAt': string;
	};

	@doc.modelUrn(ProductVariantModel) declare source: ProductVariantModel;
	@doc.model(CodeEntertainmentModel) declare codeEntertainment: CodeEntertainmentModel;

	public getTitle(language: SupportedLanguage) {
		return this.get(`translations.${language}.title`, '');
	}
}